import React from 'react';
import {ConstraintDataPlugin, ConstraintPluginProps} from '../ConstraintDataPlugin';
import {
    ConstraintType, DataTypeConstraintDto,
    FloatRangeConstraintDataDto
} from '../../../../../../common/apis/datatype/DataTypeConstraintDto';
import {CoreDataType} from "../../../../../../common/apis/datatype/DataTypeDefinitionDto";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import {FloatRangeConstraintPluginForm} from "./FloatRangeConstraintPluginForm";
import {TranslationFunction} from "../../../../../../store/localization/TranslMessasge";
import {ConstraintValueValidationPlugin} from "../ConstraintValueValidationPlugin";
import {CommonTranslationKey} from "../../../CommonTranslationKey";
import {StereotypesTranslationKey} from "../../../stereotypes/StereotypesTranslationKey";

export class FloatRangeConstraintPlugin implements ConstraintDataPlugin<FloatRangeConstraintDataDto>, ConstraintValueValidationPlugin {
    readonly type = ConstraintType.FLOAT_RANGE;

    getSupportedDataTypes(): CoreDataType[] {
        return [
            CoreDataType.FLOAT
        ];
    }

    getInitialData(): FloatRangeConstraintDataDto {
        return {
            type: ConstraintType.FLOAT_RANGE,
            min: 0.00,
            max: 100.00
        };
    }

    render(props: ConstraintPluginProps<FloatRangeConstraintDataDto>): React.ReactElement {
        return <FloatRangeConstraintPluginForm {...props} />;
    }

    validate(data: FloatRangeConstraintDataDto, coreDataType: CoreDataType): Record<string, string> {
        const errors: Record<string, string> = {};

        if ((data.min === null || data.min === undefined) && (data.max === null || data.max === undefined)) {
            errors.min = DataTypeTranslationKey.AT_LEAST_ONE_OF_MIN_OR_MAX_MUST_BE_SPECIFIED;
        } else if (data.min && data.max && data.min > data.max) {
            errors.min = DataTypeTranslationKey.MIN_VALUE_MUST_BE_LESS_THAN_OR_EQUAL_TO_MAX;
        }

        return errors;
    }

    getConstraintExpression(data: FloatRangeConstraintDataDto): string {
        const {min, max} = data;

        if (min === undefined && max === undefined) return "";

        const left = min !== null && min !== undefined ? min.toFixed(2) : "-∞";
        const right = max !== null && max !== undefined ? max.toFixed(2) : "∞";

        return `<${left}, ${right}>`;
    }

    validateValue(value: any, attributeId: string, constraint: DataTypeConstraintDto, t: TranslationFunction): Record<string, string> {
        const constraintData = constraint.constraintData as FloatRangeConstraintDataDto;
        const {min, max} = constraintData;

        if (!value) {
            return this.errorResult(t(CommonTranslationKey.FILL_OUT_THIS_FIELD), attributeId);
        }
        const convertedValue = parseFloat(value);
        if (isNaN(convertedValue)) {
            return this.errorResult(t(StereotypesTranslationKey.VALUE_IS_NOT_VALID_FLOAT), attributeId);
        }
        if (min != null && convertedValue < min) {
            return this.errorResult(t(StereotypesTranslationKey.VALUE_IS_BELLOW_ALLOWED_LIMIT), attributeId);
        }
        if (max != null && convertedValue > max) {
            return this.errorResult(t(StereotypesTranslationKey.VALUE_IS_ABOVE_ALLOWED_LIMIT), attributeId);
        }

        return {};
    }

    private errorResult(error: string, attributeId: string) {
        return {
            [attributeId]: error
        };
    }

}
